"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetadataApi = void 0;
const language_code_mapper_1 = require("../../mappers/language-code.mapper");
const generated_1 = require("./generated");
class MetadataApi {
    constructor(configuration, basePath, axios) {
        this.api = new generated_1.MetadataApi(configuration, basePath, axios);
        this.languageCodeMapper = new language_code_mapper_1.LanguageCodeMapper();
    }
    async getMetadataV1({ phrase, targetLanguage, secret, userData }, options) {
        return this.api.getMetadataV1({ phrase, targetLanguage: this.languageCodeMapper.mapFromGenerated(targetLanguage), secret, userData }, options);
    }
    async getPronunciationMetadataV1({ words, language, secret, userData }, options) {
        return this.api.getPronunciationMetadataV1({ words, language: this.languageCodeMapper.mapFromGenerated(language), secret, userData }, options);
    }
}
exports.MetadataApi = MetadataApi;
//# sourceMappingURL=metadata-api.js.map